"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TitleLayout = exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { isFirst = false, theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        padding: isFirst ? theme.spacing(1, 0, 4, 0) : theme.spacing(4, 0),
        width: '100%',
        justifyContent: 'space-between',
        cursor: 'pointer',
        userSelect: 'none'
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        maxWidth: 'calc(100% - 55px)',
        wordBreak: 'break-word',
        hyphens: 'auto'
    };
});
const TitleLayout = exports.TitleLayout = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginRight: theme.spacing(2),
        gap: theme.spacing(1),
        display: 'flex',
        alignItems: 'center'
    };
});
